<template>
  <!-- Mobil oldalsó menü -->
  <v-navigation-drawer v-model="drawer" temporary location="right" width="280">
    <div class="drawer-header">
      <img :src="logo" alt="Kreatív Hímző Kuckó" class="drawer-logo" />
    </div>
    <v-divider></v-divider>
    <v-list nav density="comfortable">
      <v-list-item
          v-for="item in navItems"
          :key="item.path"
          :active="isActive(item.path)"
          color="primary"
          rounded="lg"
          :title="item.title"
          @click="go(item.path)"
      >
        <template v-slot:prepend>
          <v-icon :icon="item.icon"></v-icon>
        </template>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <div class="pa-4">
        <v-btn block color="primary" variant="flat" prepend-icon="mdi-phone" @click="go('/connection')">
          Kapcsolat
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>

  <!-- Fejléc -->
  <v-app-bar
      flat
      :elevation="scrolled ? 4 : 0"
      :color="scrolled ? 'surface' : 'transparent'"
      :class="['hk-appbar', { 'hk-appbar--scrolled': scrolled }]"
      height="76"
  >
    <div class="hk-appbar__inner">
      <!-- Logó -->
      <button class="hk-brand" @click="go('/')" aria-label="Főoldal">
        <img :src="logo" alt="Kreatív Hímző Kuckó" class="hk-brand__logo" />
      </button>

      <v-spacer></v-spacer>

      <!-- Asztali menü -->
      <nav class="hk-nav d-none d-md-flex">
        <button
            v-for="item in navItems"
            :key="item.path"
            class="hk-nav__link"
            :class="{ 'hk-nav__link--active': isActive(item.path) }"
            @click="go(item.path)"
        >
          {{ item.title }}
        </button>
        <v-btn class="ms-3" color="primary" variant="flat" prepend-icon="mdi-phone" @click="go('/connection')">
          Ajánlatkérés
        </v-btn>
      </nav>

      <!-- Mobil hamburger -->
      <v-app-bar-nav-icon
          class="d-flex d-md-none"
          @click="drawer = !drawer"
      />
    </div>
  </v-app-bar>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";

@Options({
  props: {
    appBarColor: String,
    appBarTextColor: String,
    elevation: String
  },
  data() {
    return {
      drawer: false,
      scrolled: false,
      logo: require("@/assets/logo.png"),
      navItems: [
        {title: "Főoldal", path: "/", icon: "mdi-home"},
        {title: "Rólunk", path: "/company", icon: "mdi-information"},
        {title: "Galéria", path: "/gallery", icon: "mdi-image-multiple"},
        {title: "Kapcsolat", path: "/connection", icon: "mdi-phone"},
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, {passive: true});
    this.onScroll();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll(): void {
      this.scrolled = window.scrollY > 20;
    },
    isActive(path: string): boolean {
      return this.$route.path === path;
    },
    go(path: string): void {
      this.drawer = false;
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    }
  }
})
export default class MainAppBar extends Vue {
}
</script>

<style scoped>
.hk-appbar {
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.hk-appbar__inner {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: var(--hk-content-max);
  margin-inline: auto;
  padding-inline: clamp(1rem, 4vw, 2rem);
}

/* Logó gomb */
.hk-brand {
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 0;
}

.hk-brand__logo {
  height: 52px;
  width: auto;
  display: block;
  /* A logó közel-fehér háttere beleolvad a krém/fehér felületbe */
  mix-blend-mode: multiply;
  transition: transform 0.25s ease;
}

.hk-brand:hover .hk-brand__logo {
  transform: scale(1.04);
}

/* Asztali navigáció */
.hk-nav {
  align-items: center;
  gap: 0.25rem;
}

.hk-nav__link {
  position: relative;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 1rem;
  color: var(--hk-ink);
  padding: 0.5rem 0.9rem;
  border-radius: var(--hk-radius);
  transition: color 0.2s ease, background-color 0.2s ease;
}

.hk-nav__link::after {
  content: "";
  position: absolute;
  left: 0.9rem;
  right: 0.9rem;
  bottom: 0.35rem;
  height: 2px;
  border-radius: 2px;
  background: var(--hk-primary);
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.25s ease;
}

.hk-nav__link:hover {
  color: var(--hk-primary);
}

.hk-nav__link:hover::after,
.hk-nav__link--active::after {
  transform: scaleX(1);
}

.hk-nav__link--active {
  color: var(--hk-primary);
}

/* Drawer fejléc */
.drawer-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem 1rem;
  background: var(--hk-surface-soft);
}

.drawer-logo {
  height: 64px;
  width: auto;
  mix-blend-mode: multiply;
}
</style>
